<template>
  <div class="row">
    <div class="col-sm-6">
      <PushNotificationForm />
    </div>
    <div class="col-sm-6">
      <PushNotificationPreview />
    </div>
  </div>
</template>

<script>
import PushNotificationForm from "./components/PushNotificationForm.vue";
import PushNotificationPreview from "./components/PushNotificationPreview.vue";
export default {
  components: {
    PushNotificationForm,
    PushNotificationPreview
  },
  data() {
    return {};
  }
};
</script>
